import { motion, AnimatePresence } from 'framer-motion'
import './CompletePayment.css' // Uses the same styles

interface SupportModalProps {
    isOpen: boolean
    onClose: () => void
}

export default function SupportModal({ isOpen, onClose }: SupportModalProps) {
    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="modal-overlay"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                >
                    <motion.div
                        className="support-modal glass"
                        initial={{ scale: 0.9, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.9, opacity: 0 }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h3 className="support-title">Contact Support</h3>
                        <p className="support-desc">Choose a method to reach our 24/7 support team:</p>

                        <div className="support-options-grid">
                            <a href="https://t.me/tetherstreaam" target="_blank" rel="noopener noreferrer" className="support-option telegram">
                                <span className="option-icon">✈️</span>
                                <div className="option-info">
                                    <span className="option-name">Telegram</span>
                                    <span className="option-detail">@tetherstreaam</span>
                                </div>
                                <span className="option-arrow">↗</span>
                            </a>

                            <a href="https://wa.me/message/ZDTUK76LA35BN1" target="_blank" rel="noopener noreferrer" className="support-option whatsapp">
                                <span className="option-icon">💬</span>
                                <div className="option-info">
                                    <span className="option-name">WhatsApp</span>
                                    <span className="option-detail">Official Channel</span>
                                </div>
                                <span className="option-arrow">↗</span>
                            </a>

                            <a href="mailto:support@flashusdt.com" className="support-option email">
                                <span className="option-icon">✉️</span>
                                <div className="option-info">
                                    <span className="option-name">Email</span>
                                    <span className="option-detail">support@flashusdt.com</span>
                                </div>
                                <span className="option-arrow">↗</span>
                            </a>
                        </div>

                        <button className="close-modal-btn" onClick={onClose}>
                            Close
                        </button>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}
